import React, { useState, useRef } from 'react'
import { useOnClickOutside } from '../../hooks'
import Hidden from '@material-ui/core/Hidden'

import { MobileNavIcon, MobileNavMenu } from '../../components'

import 'fontsource-parisienne'
import 'fontsource-crimson-text'

import '../reset.sass'
import '../Layout.sass'
import 'instantsearch.css/themes/algolia.css'

const HomeLayout = ({ children }) => {
  const [open, setOpen] = useState(false)
  const node = useRef()
  useOnClickOutside(node, () => setOpen(false))
  return (
    <>
      <Hidden mdUp>
        <div ref={node}>
          <MobileNavIcon open={open} setOpen={setOpen} />
          <MobileNavMenu open={open} setOpen={setOpen} />
        </div>
      </Hidden>
      {children}
    </>
  )
}

export default HomeLayout
